import { useBlackrollAuth } from '@/composables/useBlackrollAuth';

/**
 * Guest component mixin - provided for backward compatibility
 * New components should use the useGuestComponent composable instead
 */
export default {
  // Create data for Options API compatibility
  data() {
    return {
      guestUser: null,
    };
  },

  // Setup function for Composition API
  setup(props, { expose }) {
    const { user } = useBlackrollAuth();

    // Create the isVisible function
    const isVisible = (block) => {
      return !block.guestOnly || !user.value; // de Morgan's Law :D
    };

    // Expose the method to template
    expose({ isVisible });

    return {
      user,
      isVisible,
    };
  },

  // Add method for Options API components
  methods: {
    isVisible(block) {
      // If setup function's isVisible is available, use it
      if (this.$options.setupState && typeof this.$options.setupState.isVisible === 'function') {
        return this.$options.setupState.isVisible(block);
      }

      // Fallback implementation using user from composable
      const { user } = useBlackrollAuth();
      return !block.guestOnly || !user.value;
    },
  },

  // Make sure user is updated in the component
  created() {
    const { user } = useBlackrollAuth();
    this.guestUser = user.value;
  },
};
